__turbopack_context__.v({
  "address": "estimateShippingModal-module-scss-module__UnLEhW__address",
  "address2": "estimateShippingModal-module-scss-module__UnLEhW__address2",
  "buttonRow": "estimateShippingModal-module-scss-module__UnLEhW__buttonRow",
  "cancelButton": "estimateShippingModal-module-scss-module__UnLEhW__cancelButton",
  "city": "estimateShippingModal-module-scss-module__UnLEhW__city",
  "cityRow": "estimateShippingModal-module-scss-module__UnLEhW__cityRow",
  "countryRow": "estimateShippingModal-module-scss-module__UnLEhW__countryRow",
  "countrySelectContainer": "estimateShippingModal-module-scss-module__UnLEhW__countrySelectContainer",
  "countrySelectControl": "estimateShippingModal-module-scss-module__UnLEhW__countrySelectControl",
  "countrySelectWrapper": "estimateShippingModal-module-scss-module__UnLEhW__countrySelectWrapper",
  "countryWrapper": "estimateShippingModal-module-scss-module__UnLEhW__countryWrapper",
  "error": "estimateShippingModal-module-scss-module__UnLEhW__error",
  "estimateShipping": "estimateShippingModal-module-scss-module__UnLEhW__estimateShipping",
  "estimateShippingForm": "estimateShippingModal-module-scss-module__UnLEhW__estimateShippingForm",
  "estimateShippingSubmit": "estimateShippingModal-module-scss-module__UnLEhW__estimateShippingSubmit",
  "estimateShippingTitle": "estimateShippingModal-module-scss-module__UnLEhW__estimateShippingTitle",
  "fontColor_error": "estimateShippingModal-module-scss-module__UnLEhW__fontColor_error",
  "fontColor_mainDarkest": "estimateShippingModal-module-scss-module__UnLEhW__fontColor_mainDarkest",
  "fontColor_mainLightest": "estimateShippingModal-module-scss-module__UnLEhW__fontColor_mainLightest",
  "fontColor_mainPrimary": "estimateShippingModal-module-scss-module__UnLEhW__fontColor_mainPrimary",
  "fontColor_mainSecondary": "estimateShippingModal-module-scss-module__UnLEhW__fontColor_mainSecondary",
  "fontColor_neutralDark": "estimateShippingModal-module-scss-module__UnLEhW__fontColor_neutralDark",
  "fontColor_neutralLight": "estimateShippingModal-module-scss-module__UnLEhW__fontColor_neutralLight",
  "fontColor_neutralMedium": "estimateShippingModal-module-scss-module__UnLEhW__fontColor_neutralMedium",
  "provinceWrapper": "estimateShippingModal-module-scss-module__UnLEhW__provinceWrapper",
  "row": "estimateShippingModal-module-scss-module__UnLEhW__row",
  "selectWrapper": "estimateShippingModal-module-scss-module__UnLEhW__selectWrapper",
  "zipcode": "estimateShippingModal-module-scss-module__UnLEhW__zipcode",
  "zipcodeInput": "estimateShippingModal-module-scss-module__UnLEhW__zipcodeInput",
});
